import { createApp } from 'vue';
import MenuButton from "./MenuButton.vue";

const els = document.querySelectorAll(".js-menuButton");
els.forEach((el) => {
  const app = createApp(MenuButton, {
    items: JSON.parse(el.dataset.items)
  });
  app.mount(el);
})